// src/notifications/services/use-mark-notifications-read.ts
// POST /api/Notifications/MarkNotificationAsRead — mark a set of notifications read.
//
// Mirrors Flutter `markUserNotificationAsRead({notificationId})`
// (notification_center_data_source_impl.dart:40-45): the body is a bare JSON
// array of notification-id strings (`jsonEncode(notificationId)`), NOT an object.
// The Flutter screen collects the ids of unread rows the user has viewed and
// flushes them on close (dispose → MarkNotificationsAsReadEvent). This mutation
// is the web equivalent; the panel calls it on close with the viewed-unread ids.
//
// On success we invalidate the notifications list so the rows lose their unread
// highlight on next open.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { post } from '@/shared/api/api-client';
import { notificationsQueryKey } from './use-notifications';

export function useMarkNotificationsRead() {
  const queryClient = useQueryClient();
  return useMutation({
    // Body is the raw string[] — matches the source's `jsonEncode(notificationId)`.
    mutationFn: (notificationIds: string[]) =>
      post<unknown>('/api/Notifications/MarkNotificationAsRead', notificationIds),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: notificationsQueryKey });
    },
  });
}
